import React, { useState, useEffect } from 'react';
import { Plus, Trash2, Edit3, BookOpen, FileText, Search, X, CheckCircle, AlertCircle } from 'lucide-react';
import { callApi, callPublicApi } from '../api';
import './YonetimSayfasi.css';
import './AkademiYonetim.css';

const KATEGORILER_SOZLUK = [
  { val: 'KESIM', label: 'Kesim Teknikleri' },
  { val: 'SOS', label: 'Sos Ekolü' },
  { val: 'PISIRME', label: 'Pişirme Yöntemi' },
  { val: 'ET_DERECE', label: 'Et Pişirme & Derece' },
  { val: 'PASTACILIK', label: 'Pastacılık & Tatlı' },
  { val: 'KULTUR', label: 'Kültür & Yerel Miras' },
  { val: 'TEKNIK', label: 'Mutfak Bilimi & Teknik' },
  { val: 'DIGER', label: 'Genel Terminoloji' }
];

const KATEGORILER_BLOG = [
  { val: 'TEKNIK', label: 'Teknik & Mutfak Bilimi' },
  { val: 'KULTUR', label: 'Yerel Miras & Kültür' },
  { val: 'TARIH', label: 'Gastronomi Tarihi' },
  { val: 'SEF', label: 'Şef Masası & Röportaj' },
  { val: 'GENEL', label: 'Genel' }
];

const AkademiYonetim = () => {
  const [activeTab, setActiveTab] = useState('sozluk'); // 'sozluk' | 'blog'
  const [sozlukList, setSozlukList] = useState([]);
  const [blogList, setBlogList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  // Modallar
  const [isSozlukModalOpen, setIsSozlukModalOpen] = useState(false);
  const [isBlogModalOpen, setIsBlogModalOpen] = useState(false);
  const [editingSozluk, setEditingSozluk] = useState(null);
  const [editingBlog, setEditingBlog] = useState(null);

  // Form State - Sözlük
  const [sozlukForm, setSozlukForm] = useState({
    terim: '',
    okunus: '',
    kategori: 'KESIM',
    kisaTanim: '',
    olculer: '',
    pufNoktasi: '',
    gorselUrl: '',
    detayliIcerik: ''
  });

  // Form State - Blog
  const [blogForm, setBlogForm] = useState({
    baslik: '',
    slug: '',
    kategori: 'TEKNIK',
    ozet: '',
    icerik: '',
    kapakResmi: '',
    yazarAdi: 'Yönetim Ekibi',
    yazarUnvan: '',
    okumaSuresiDk: 4,
    yayinda: 1
  });

  // Verileri çek
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const [sData, bData] = await Promise.all([
        callPublicApi('/sozluk'),
        callPublicApi('/blog?all=1')
      ]);
      setSozlukList(sData.items || []);
      setBlogList(bData.items || []);
    } catch (err) {
      console.error('Akademi yükleme hatası:', err);
      setError('Veriler yüklenemedi: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const showNotification = (msg) => {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(''), 4000);
  };

  // --- SÖZLÜK HANDLERS ---
  const handleOpenNewSozluk = () => {
    setEditingSozluk(null);
    setSozlukForm({
      terim: '',
      okunus: '',
      kategori: 'KESIM',
      kisaTanim: '',
      olculer: '',
      pufNoktasi: '',
      gorselUrl: '',
      detayliIcerik: ''
    });
    setIsSozlukModalOpen(true);
  };

  const handleEditSozluk = (item) => {
    setEditingSozluk(item);
    setSozlukForm({
      terim: item.terim || '',
      okunus: item.okunus || '',
      kategori: item.kategori || 'KESIM',
      kisaTanim: item.kisaTanim || '',
      olculer: item.olculer || '',
      pufNoktasi: item.pufNoktasi || '',
      gorselUrl: item.gorselUrl || '',
      detayliIcerik: item.detayliIcerik || ''
    });
    setIsSozlukModalOpen(true);
  };

  const handleSaveSozluk = async (e) => {
    e.preventDefault();
    if (!sozlukForm.terim || !sozlukForm.kisaTanim) {
      alert('Lütfen terim ve kısa tanımı doldurun.');
      return;
    }

    setIsSaving(true);
    try {
      if (editingSozluk) {
        await callApi(`/sozluk/${editingSozluk.id}`, 'PUT', sozlukForm);
        showNotification('Terim başarıyla güncellendi.');
      } else {
        await callApi('/sozluk', 'POST', sozlukForm);
        showNotification('Yeni terim başarıyla eklendi.');
      }
      setIsSozlukModalOpen(false);
      fetchData();
    } catch (err) {
      alert('Hata oluştu: ' + err.message);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteSozluk = async (id, terim) => {
    if (!window.confirm(`"${terim}" terimini silmek istediğinize emin misiniz?`)) return;
    try {
      await callApi(`/sozluk/${id}`, 'DELETE');
      showNotification('Terim silindi.');
      fetchData();
    } catch (err) {
      alert('Silinemedi: ' + err.message);
    }
  };

  // --- BLOG HANDLERS ---
  const handleOpenNewBlog = () => {
    setEditingBlog(null);
    setBlogForm({
      baslik: '',
      slug: '',
      kategori: 'TEKNIK',
      ozet: '',
      icerik: '',
      kapakResmi: '',
      yazarAdi: 'Yönetim Ekibi',
      yazarUnvan: '',
      okumaSuresiDk: 4,
      yayinda: 1
    });
    setIsBlogModalOpen(true);
  };

  const handleEditBlog = (item) => {
    setEditingBlog(item);
    setBlogForm({
      baslik: item.baslik || '',
      slug: item.slug || '',
      kategori: item.kategori || 'TEKNIK',
      ozet: item.ozet || '',
      icerik: item.icerik || '',
      kapakResmi: item.kapakResmi || '',
      yazarAdi: item.yazarAdi || 'Yönetim Ekibi',
      yazarUnvan: item.yazarUnvan || '',
      okumaSuresiDk: item.okumaSuresiDk || 4,
      yayinda: item.yayinda !== undefined ? item.yayinda : 1
    });
    setIsBlogModalOpen(true);
  };

  const handleSaveBlog = async (e) => {
    e.preventDefault();
    if (!blogForm.baslik || !blogForm.icerik) {
      alert('Lütfen başlık ve içerik alanlarını doldurun.');
      return;
    }

    setIsSaving(true);
    try {
      const payload = {
        ...blogForm,
        yazarAdi: blogForm.yazarAdi || 'Yönetim Ekibi',
        yazarUnvan: null
      };

      if (editingBlog) {
        await callApi(`/blog/${editingBlog.id}`, 'PUT', payload);
        showNotification('Blog yazısı güncellendi.');
      } else {
        await callApi('/blog', 'POST', payload);
        showNotification('Yeni blog yazısı yayınlandı.');
      }
      setIsBlogModalOpen(false);
      fetchData();
    } catch (err) {
      alert('Hata: ' + err.message);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteBlog = async (id, baslik) => {
    if (!window.confirm(`"${baslik}" yazısını silmek istediğinize emin misiniz?`)) return;
    try {
      await callApi(`/blog/${id}`, 'DELETE');
      showNotification('Blog yazısı silindi.');
      fetchData();
    } catch (err) {
      alert('Silinemedi: ' + err.message);
    }
  };

  const filteredSozluk = sozlukList.filter(item =>
    item.terim?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.kisaTanim?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredBlog = blogList.filter(item =>
    item.baslik?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.ozet?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="akademi-yonetim-page">
      {/* BAŞLIK & EKLEME BUTONU */}
      <div className="akademi-page-header">
        <div className="akademi-title-area">
          <h2>🎓 Gastro Akademi Yönetimi</h2>
          <p>Mutfak sözlüğü terimlerini, teknik ölçülerini ve blog yazılarını buradan yönetin.</p>
        </div>
        <div>
          {activeTab === 'sozluk' ? (
            <button className="akademi-add-btn" onClick={handleOpenNewSozluk}>
              <Plus size={18} /> Yeni Terim Ekle
            </button>
          ) : (
            <button className="akademi-add-btn" onClick={handleOpenNewBlog}>
              <Plus size={18} /> Yeni Yazı Yaz
            </button>
          )}
        </div>
      </div>

      {/* BİLDİRİMLER */}
      {successMsg && (
        <div className="akademi-alert success">
          <CheckCircle size={18} /> {successMsg}
        </div>
      )}

      {error && (
        <div className="akademi-alert error">
          <AlertCircle size={18} /> {error}
        </div>
      )}

      {/* ARAÇ ÇUBUĞU: SEKMELER & ARAMA */}
      <div className="akademi-toolbar">
        <div className="akademi-tabs">
          <button
            className={`akademi-tab-btn ${activeTab === 'sozluk' ? 'active' : ''}`}
            onClick={() => setActiveTab('sozluk')}
          >
            <BookOpen size={16} />
            <span>Mutfak Sözlüğü</span>
            <span className="akademi-badge-count">{sozlukList.length}</span>
          </button>
          <button
            className={`akademi-tab-btn ${activeTab === 'blog' ? 'active' : ''}`}
            onClick={() => setActiveTab('blog')}
          >
            <FileText size={16} />
            <span>Gastro Blog</span>
            <span className="akademi-badge-count">{blogList.length}</span>
          </button>
        </div>

        <div className="akademi-search-wrapper">
          <Search size={16} className="akademi-search-icon" />
          <input
            type="text"
            className="akademi-search-input"
            placeholder={activeTab === 'sozluk' ? 'Terimlerde ara...' : 'Blog yazılarında ara...'}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button
              type="button"
              className="akademi-search-clear"
              onClick={() => setSearchTerm('')}
              aria-label="Aramayı Temizle"
            >
              <X size={14} />
            </button>
          )}
        </div>
      </div>

      {/* YÜKLENİYOR */}
      {loading ? (
        <div className="akademi-loading-state">
          Veriler yükleniyor, lütfen bekleyin...
        </div>
      ) : activeTab === 'sozluk' ? (
        /* SÖZLÜK İÇERİĞİ */
        <>
          {/* Masaüstü Tablo Görünümü (>= 769px) */}
          <div className="akademi-desktop-table">
            <table className="akademi-table">
              <thead>
                <tr>
                  <th>Terim & Okunuş</th>
                  <th>Kategori</th>
                  <th>Standart Ölçü</th>
                  <th>Tanım & Püf Noktası</th>
                  <th style={{ textAlign: 'right' }}>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {filteredSozluk.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '35px', color: '#94a3b8' }}>
                      Kayıtlı terim bulunamadı.
                    </td>
                  </tr>
                ) : (
                  filteredSozluk.map(item => (
                    <tr key={item.id}>
                      <td>
                        <strong>{item.terim}</strong>
                        {item.okunus && <div className="akademi-phonetic">[{item.okunus}]</div>}
                      </td>
                      <td>
                        <span className="akademi-badge-cat">
                          {item.kategori}
                        </span>
                      </td>
                      <td>{item.olculer || '-'}</td>
                      <td style={{ maxWidth: '360px' }}>
                        <div className="akademi-desc-text">{item.kisaTanim}</div>
                        {item.pufNoktasi && (
                          <div className="akademi-tip-text">
                            💡 <em>{item.pufNoktasi}</em>
                          </div>
                        )}
                      </td>
                      <td style={{ textAlign: 'right' }}>
                        <div className="akademi-row-actions">
                          <button className="action-btn edit" onClick={() => handleEditSozluk(item)} title="Düzenle">
                            <Edit3 size={16} />
                          </button>
                          <button className="action-btn delete" onClick={() => handleDeleteSozluk(item.id, item.terim)} title="Sil">
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Mobil Kart Görünümü (< 769px) - Tam Simetrik & Dokunmatik */}
          <div className="akademi-mobile-cards">
            {filteredSozluk.length === 0 ? (
              <div className="akademi-empty-state">Kayıtlı terim bulunamadı.</div>
            ) : (
              filteredSozluk.map(item => (
                <div key={item.id} className="akademi-mobile-card">
                  <div className="akademi-card-header">
                    <div>
                      <h4 className="akademi-card-title">{item.terim}</h4>
                      {item.okunus && <span className="akademi-phonetic">[{item.okunus}]</span>}
                    </div>
                    <span className="akademi-badge-cat">{item.kategori}</span>
                  </div>

                  {item.olculer && (
                    <div className="akademi-card-measure">
                      <span>🏷️</span>
                      <span>{item.olculer}</span>
                    </div>
                  )}

                  <p className="akademi-card-desc">{item.kisaTanim}</p>

                  {item.pufNoktasi && (
                    <div className="akademi-card-tip">
                      <span>💡</span>
                      <span>{item.pufNoktasi}</span>
                    </div>
                  )}

                  <div className="akademi-card-actions">
                    <button className="akademi-btn-card-edit" onClick={() => handleEditSozluk(item)}>
                      <span className="akademi-btn-emoji">✏️</span> Düzenle
                    </button>
                    <button className="akademi-btn-card-delete" onClick={() => handleDeleteSozluk(item.id, item.terim)}>
                      <span className="akademi-btn-emoji">🗑️</span> Sil
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      ) : (
        /* BLOG İÇERİĞİ */
        <>
          {/* Masaüstü Tablo Görünümü (>= 769px) */}
          <div className="akademi-desktop-table">
            <table className="akademi-table">
              <thead>
                <tr>
                  <th>Görsel & Başlık</th>
                  <th>Kategori</th>
                  <th>Yazar</th>
                  <th>Okunma</th>
                  <th>Durum</th>
                  <th style={{ textAlign: 'right' }}>İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {filteredBlog.length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '35px', color: '#94a3b8' }}>
                      Yazı bulunamadı.
                    </td>
                  </tr>
                ) : (
                  filteredBlog.map(art => (
                    <tr key={art.id}>
                      <td>
                        <div className="akademi-blog-col">
                          {art.kapakResmi && (
                            <img src={art.kapakResmi} alt="" className="akademi-blog-col-img" />
                          )}
                          <div>
                            <strong>{art.baslik}</strong>
                            <div className="akademi-phonetic">⏱️ {art.okumaSuresiDk || 3} dk okuma</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="akademi-badge-cat">{art.kategori}</span>
                      </td>
                      <td>
                        <div style={{ fontWeight: 600 }}>{art.yazarAdi || 'Yönetim Ekibi'}</div>
                      </td>
                      <td>👁️ {art.okunmaSayisi || 0}</td>
                      <td>
                        <span className={`badge ${art.yayinda ? 'badge-success' : 'badge-warning'}`}>
                          {art.yayinda ? 'Yayında' : 'Taslak'}
                        </span>
                      </td>
                      <td style={{ textAlign: 'right' }}>
                        <div className="akademi-row-actions">
                          <button className="action-btn edit" onClick={() => handleEditBlog(art)} title="Düzenle">
                            <Edit3 size={16} />
                          </button>
                          <button className="action-btn delete" onClick={() => handleDeleteBlog(art.id, art.baslik)} title="Sil">
                            <Trash2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Mobil Kart Görünümü (< 769px) - Tam Simetrik & Dokunmatik */}
          <div className="akademi-mobile-cards">
            {filteredBlog.length === 0 ? (
              <div className="akademi-empty-state">Yazı bulunamadı.</div>
            ) : (
              filteredBlog.map(art => (
                <div key={art.id} className="akademi-mobile-card">
                  <div className="akademi-blog-card-top">
                    {art.kapakResmi && (
                      <img src={art.kapakResmi} alt="" className="akademi-blog-card-img" />
                    )}
                    <div className="akademi-blog-card-header">
                      <div className="akademi-card-badges">
                        <span className="akademi-badge-cat">{art.kategori}</span>
                        <span className={`badge ${art.yayinda ? 'badge-success' : 'badge-warning'}`}>
                          {art.yayinda ? 'Yayında' : 'Taslak'}
                        </span>
                      </div>
                      <h4 className="akademi-card-title">{art.baslik}</h4>
                    </div>
                  </div>

                  <div className="akademi-card-meta">
                    <span>✍️ {art.yazarAdi || 'Yönetim Ekibi'}</span>
                    <span>⏱️ {art.okumaSuresiDk || 3} dk</span>
                    <span>👁️ {art.okunmaSayisi || 0}</span>
                  </div>

                  {art.ozet && (
                    <p className="akademi-card-desc">{art.ozet}</p>
                  )}

                  <div className="akademi-card-actions">
                    <button className="akademi-btn-card-edit" onClick={() => handleEditBlog(art)}>
                      <span className="akademi-btn-emoji">✏️</span> Düzenle
                    </button>
                    <button className="akademi-btn-card-delete" onClick={() => handleDeleteBlog(art.id, art.baslik)}>
                      <span className="akademi-btn-emoji">🗑️</span> Sil
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      )}

      {/* SÖZLÜK MODAL */}
      {isSozlukModalOpen && (
        <div className="akademi-modal-overlay" onClick={() => setIsSozlukModalOpen(false)}>
          <div className="akademi-modal-card" style={{ maxWidth: '640px' }} onClick={e => e.stopPropagation()}>
            <div className="akademi-modal-header">
              <div className="akademi-header-left">
                <div className="akademi-header-icon">
                  <BookOpen size={22} />
                </div>
                <div>
                  <h3>{editingSozluk ? 'Terim Düzenle' : 'Yeni Mutfak Terimi Ekle'}</h3>
                  <p>Mutfak sözlüğü terimini, fonetik okunuşunu ve standart ölçülerini tanımlayın</p>
                </div>
              </div>
              <button 
                type="button" 
                className="akademi-close-btn" 
                onClick={() => setIsSozlukModalOpen(false)}
                aria-label="Kapat"
              >
                <X size={18} />
              </button>
            </div>

            <form onSubmit={handleSaveSozluk} className="akademi-modal-form">
              <div className="akademi-modal-body">
                <div className="akademi-grid-2">
                  <div className="akademi-form-group">
                    <label className="akademi-label">
                      Terim Adı <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      className="akademi-input"
                      value={sozlukForm.terim}
                      onChange={e => setSozlukForm({ ...sozlukForm, terim: e.target.value })}
                      placeholder="örn: Brunoise"
                    />
                  </div>
                  <div className="akademi-form-group">
                    <label className="akademi-label">
                      Fonetik Okunuş
                      <span className="akademi-label-sub">İsteğe bağlı</span>
                    </label>
                    <input
                      type="text"
                      className="akademi-input"
                      value={sozlukForm.okunus}
                      onChange={e => setSozlukForm({ ...sozlukForm, okunus: e.target.value })}
                      placeholder="örn: Brunuaz"
                    />
                  </div>
                </div>

                <div className="akademi-grid-2">
                  <div className="akademi-form-group">
                    <label className="akademi-label">Kategori</label>
                    <select
                      className="akademi-select"
                      value={sozlukForm.kategori}
                      onChange={e => setSozlukForm({ ...sozlukForm, kategori: e.target.value })}
                    >
                      {KATEGORILER_SOZLUK.map(k => (
                        <option key={k.val} value={k.val}>{k.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="akademi-form-group">
                    <label className="akademi-label">
                      Standart Ölçüler
                      <span className="akademi-label-sub">Varsa</span>
                    </label>
                    <input
                      type="text"
                      className="akademi-input"
                      value={sozlukForm.olculer}
                      onChange={e => setSozlukForm({ ...sozlukForm, olculer: e.target.value })}
                      placeholder="örn: 1-2mm × 1-2mm × 1-2mm"
                    />
                  </div>
                </div>

                <div className="akademi-form-group">
                  <label className="akademi-label">
                    Kısa Tanım <span className="req">*</span>
                  </label>
                  <textarea
                    required
                    rows="3"
                    className="akademi-textarea"
                    value={sozlukForm.kisaTanim}
                    onChange={e => setSozlukForm({ ...sozlukForm, kisaTanim: e.target.value })}
                    placeholder="Terimin kısa ve net açıklaması..."
                  />
                </div>

                <div className="akademi-tip-box">
                  <div className="akademi-form-group" style={{ margin: 0 }}>
                    <label className="akademi-label" style={{ marginBottom: '6px' }}>
                      <span>💡 Şefin Püf Noktası</span>
                      <span className="akademi-label-sub" style={{ color: '#d97706' }}>Kritik Şef İpucu</span>
                    </label>
                    <input
                      type="text"
                      className="akademi-input"
                      value={sozlukForm.pufNoktasi}
                      onChange={e => setSozlukForm({ ...sozlukForm, pufNoktasi: e.target.value })}
                      placeholder="Şeflerin uyguladığı kritik ipucu veya teknik sır..."
                    />
                  </div>
                </div>

                <div className="akademi-form-group">
                  <label className="akademi-label">
                    Görsel URL
                    <span className="akademi-label-sub">İsteğe bağlı (Unsplash veya web linki)</span>
                  </label>
                  <input
                    type="url"
                    className="akademi-input"
                    value={sozlukForm.gorselUrl}
                    onChange={e => setSozlukForm({ ...sozlukForm, gorselUrl: e.target.value })}
                    placeholder="https://images.unsplash.com/..."
                  />
                  {sozlukForm.gorselUrl && (
                    <div style={{ marginTop: '8px', borderRadius: '10px', overflow: 'hidden', maxHeight: '120px', border: '1px solid #e2e8f0' }}>
                      <img 
                        src={sozlukForm.gorselUrl} 
                        alt="Önizleme" 
                        style={{ width: '100%', height: '120px', objectFit: 'cover', display: 'block' }} 
                        onError={(e) => { e.target.style.display = 'none'; }} 
                      />
                    </div>
                  )}
                </div>

                <div className="akademi-form-group">
                  <label className="akademi-label">
                    Detaylı Açıklama / Kullanım Notları
                  </label>
                  <textarea
                    rows="4"
                    className="akademi-textarea"
                    value={sozlukForm.detayliIcerik}
                    onChange={e => setSozlukForm({ ...sozlukForm, detayliIcerik: e.target.value })}
                    placeholder="Tarihçesi, hangi yemeklerde ve reçetelerde kullanıldığı, detaylı açıklamalar..."
                  />
                </div>
              </div>

              <div className="akademi-modal-footer">
                <button 
                  type="button" 
                  className="akademi-btn-cancel" 
                  onClick={() => setIsSozlukModalOpen(false)}
                  disabled={isSaving}
                >
                  İptal
                </button>
                <button type="submit" className="akademi-btn-submit" disabled={isSaving}>
                  {isSaving ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* BLOG MODAL */}
      {isBlogModalOpen && (
        <div className="akademi-modal-overlay" onClick={() => setIsBlogModalOpen(false)}>
          <div className="akademi-modal-card" style={{ maxWidth: '780px' }} onClick={e => e.stopPropagation()}>
            <div className="akademi-modal-header">
              <div className="akademi-header-left">
                <div className="akademi-header-icon blog-icon">
                  <FileText size={22} />
                </div>
                <div>
                  <h3>{editingBlog ? 'Blog Yazısını Düzenle' : 'Yeni Blog Yazısı Oluştur'}</h3>
                  <p>Gastro Akademi eğitim makalesini, kapak görselini ve içeriğini düzenleyin</p>
                </div>
              </div>
              <button 
                type="button" 
                className="akademi-close-btn" 
                onClick={() => setIsBlogModalOpen(false)}
                aria-label="Kapat"
              >
                <X size={18} />
              </button>
            </div>

            <form onSubmit={handleSaveBlog} className="akademi-modal-form">
              <div className="akademi-modal-body">
                <div className="akademi-form-group">
                  <label className="akademi-label">
                    Makale Başlığı <span className="req">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    className="akademi-input"
                    value={blogForm.baslik}
                    onChange={e => setBlogForm({ ...blogForm, baslik: e.target.value })}
                    placeholder="Örn: Topraktan Sofraya: Kırklareli ve Trakya'nın Gastronomik Mirası"
                  />
                </div>

                <div className="akademi-grid-2">
                  <div className="akademi-form-group">
                    <label className="akademi-label">Kategori</label>
                    <select
                      className="akademi-select"
                      value={blogForm.kategori}
                      onChange={e => setBlogForm({ ...blogForm, kategori: e.target.value })}
                    >
                      {KATEGORILER_BLOG.map(k => (
                        <option key={k.val} value={k.val}>{k.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="akademi-form-group">
                    <label className="akademi-label">Okuma Süresi (Dakika)</label>
                    <input
                      type="number"
                      min="1"
                      className="akademi-input"
                      value={blogForm.okumaSuresiDk}
                      onChange={e => setBlogForm({ ...blogForm, okumaSuresiDk: Number(e.target.value) })}
                    />
                  </div>
                </div>

                <div className="akademi-grid-2">
                  <div className="akademi-form-group">
                    <label className="akademi-label">Kapak Resmi URL</label>
                    <input
                      type="url"
                      className="akademi-input"
                      value={blogForm.kapakResmi}
                      onChange={e => setBlogForm({ ...blogForm, kapakResmi: e.target.value })}
                      placeholder="https://images.unsplash.com/..."
                    />
                  </div>
                  <div className="akademi-form-group">
                    <label className="akademi-label">
                      Yazar Adı
                      <span className="akademi-label-sub">Varsayılan: Yönetim Ekibi</span>
                    </label>
                    <input
                      type="text"
                      className="akademi-input"
                      value={blogForm.yazarAdi || 'Yönetim Ekibi'}
                      onChange={e => setBlogForm({ ...blogForm, yazarAdi: e.target.value })}
                    />
                  </div>
                </div>

                <div className="akademi-form-group">
                  <label className="akademi-label">
                    Kısa Özet / Spot Cümle <span className="req">*</span>
                  </label>
                  <textarea
                    required
                    rows="2"
                    className="akademi-textarea"
                    value={blogForm.ozet}
                    onChange={e => setBlogForm({ ...blogForm, ozet: e.target.value })}
                    placeholder="Yazının ana temasını anlatan çarpıcı giriş özeti..."
                  />
                </div>

                <div className="akademi-form-group">
                  <label className="akademi-label">
                    Makale İçeriği (Markdown veya Düz Metin) <span className="req">*</span>
                  </label>
                  <textarea
                    required
                    rows="9"
                    className="akademi-textarea"
                    style={{ minHeight: '180px', fontFamily: 'monospace, sans-serif', fontSize: '0.85rem' }}
                    value={blogForm.icerik}
                    onChange={e => setBlogForm({ ...blogForm, icerik: e.target.value })}
                    placeholder="Makalenin tam içeriği..."
                  />
                </div>

                <label className="akademi-toggle-card">
                  <input
                    type="checkbox"
                    id="yayindaCheck"
                    checked={Boolean(blogForm.yayinda)}
                    onChange={e => setBlogForm({ ...blogForm, yayinda: e.target.checked ? 1 : 0 })}
                  />
                  <div>
                    <div className="akademi-toggle-title">Yazıyı doğrudan yayına al</div>
                    <div className="akademi-toggle-desc">İşaretlenmezse Taslak olarak kaydedilir ve sitede gösterilmez</div>
                  </div>
                </label>
              </div>

              <div className="akademi-modal-footer">
                <button 
                  type="button" 
                  className="akademi-btn-cancel" 
                  onClick={() => setIsBlogModalOpen(false)}
                  disabled={isSaving}
                >
                  İptal
                </button>
                <button type="submit" className="akademi-btn-submit" disabled={isSaving}>
                  {isSaving ? 'Kaydediliyor...' : 'Yazıyı Kaydet'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AkademiYonetim;
